import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import 'react-toggle/style.css';
import {Button, buttonTypes} from '../../../components/Button';
import Input from '../../../components/Input';
import {validationRegister} from '../../../utils/validationUtils';
import {submitRegister, showLogin} from "../Actions";

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeIsVendor = this.onChangeIsVendor.bind(this);
    this.state = {
      isError: false,
      error: {},
      email: '',
      name: '',
      lastName: '',
      companyName: '',
      password: '',
      confirmPassword: '',
      isVendor: true,
      vendorType: 'tour'
    }
  }

  componentWillReceiveProps(next) {
    this.setState({
      error: next.error
    })
  }

  static propTypes = {
    history: PropTypes.object,
    submit: PropTypes.func,
    showLogin: PropTypes.func,
  };

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    }, () => {
      this.setState({error: {}})
    });
  }

  onChangeIsVendor() {
    this.setState({isVendor: !this.state.isVendor}, () => {
      let vendorType = 'disable';
      if (this.state.isVendor) {
        vendorType = 'tour'
      }
      this.setState({vendorType})
    })
  }

  handleSubmit() {
    const data = {...this.state};
    const isValid = validationRegister(data);
    if (isValid.isError) {
      this.setState({...isValid})
    } else {
      this.props.submit({
        email: data.email.trim(),
        name: data.name,
        lastName: data.lastName,
        companyName: data.companyName,
        password: data.password.trim(),
        vendorType: data.vendorType
      }, this.props.history)
    }
  }

  render() {
    const {
      error,
      email,
      password,
      name,
      lastName,
      confirmPassword,
      isVendor,
      companyName
    } = this.state;

    return (
      <div className="modal__wrap modal__registration">
        <header>
          <h3 className="modal__title">Registration</h3>
          <p className="modal__description">Create an account.</p>
        </header>
        <Input
          type="text"
          label="First name"
          placeholder="First name"
          value={name}
          name="name"
          error={error.name}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="text"
          label="Last name"
          placeholder="Last name"
          value={lastName}
          name="lastName"
          error={error.lastName}
          onChange={(e) => this.handleChange(e)}
        />
        {isVendor ?
          <Input
            type="text"
            label="Company name"
            placeholder="Company name"
            value={companyName}
            name="companyName"
            error={error.companyName}
            onChange={(e) => this.handleChange(e)}
          /> : null
        }
        <Input
          type="email"
          label="E-mail address"
          placeholder="Email"
          value={email}
          name="email"
          error={error.email}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="password"
          label="Password"
          placeholder="Password"
          value={password}
          name="password"
          error={error.password}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="password"
          label="Confirm Password"
          placeholder="Password"
          value={confirmPassword}
          name="confirmPassword"
          error={error.confirmPassword}
          onChange={(e) => this.handleChange(e)}
        />
        <Button
          name="Register"
          type={buttonTypes.AUTHENTICATION}
          onClick={() => this.handleSubmit()}
        />
        <footer>
          <span className="modal__question">Already have an account?</span>
          <Button
            type={buttonTypes.LINK}
            name="Go to login"
            onClick={() => this.props.showLogin()}
          />
        </footer>
      </div>
    )
  }
}

export default connect(
  s => ({
    error: s.auth.error,
  }),
  d => ({
    submit: (data, history) => {
      d(submitRegister(data, history))
    },
    showLogin: () => {
      d(showLogin())
    }
  })
)(Register);


// WEBPACK FOOTER //
// ./src/app/containers/Auth/components/register.js